module.exports = __webpack_public_path__ + "static/media/bird-goose1.7cb505c1.aac";